import { types } from '../../../constants/ActionTypes'
import { deepCopy } from '../../../lib'

const initialState = {
  path: '',
  urlParams: {},
  search: {},
  records: [],
  totalRows: 0,
  totalPage: 0,
  anchorEl: null,
  isFetching: true,
  ready: false,
}

const puzzleListCard = (state = initialState, action) => {
  var totalRows, totalPage
  switch (action.type) {
    case types.puzzleListCard.UNMOUNT:
      return deepCopy(initialState)
    case types.puzzleListCard.CHANGED_URL_PARAMS:
      return {
        ...state,
        urlParams: {
          ...state.urlParams,
          ...action.urlParams
        }
      }
    case types.puzzleListCard.REQUEST_SELECT_PUZZLE:
      return { ...state, isFetching: true }
    case types.puzzleListCard.RESPONSE_SELECT_PUZZLE:
      if (action.response.records === undefined) {
        return { ...state, records: [], isFetching: false, ready: true }
      }
      totalRows = action.response.total ? parseInt(action.response.total, 10) : 0
      totalPage = Math.ceil(totalRows / state.urlParams.rowsPerPage)
      return {
        ...state,
        records: action.response.records,
        search: action.response.search,
        totalRows,
        totalPage,
        isFetching: false,
        ready: true,
      }
    case types.puzzleListCard.menu.OPEN:
      return { ...state, anchorEl: action.anchorEl }
    case types.puzzleListCard.menu.CLOSE:
      return { ...state, anchorEl: null }
    default:
      return state
  }
}

export default puzzleListCard



// WEBPACK FOOTER //
// ./src/reducers/Common/Puzzle/PuzzleListCard.js